"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shadowLight = {
    subtle: '0px 4px 8px rgba(62, 67, 73, 0.2)',
    strong: '0px 8px 16px rgba(62, 67, 73, 0.25)',
    perspective: '0px 6px 12px rgba(62, 67, 73, 0.25)',
    distant: '0px 24px 32px rgba(62, 67, 73, 0.3)'
};
//# sourceMappingURL=shadows.js.map